import React from 'react';

type Props = { children: React.ReactNode; component?: string };

export default class LocalErrorBoundary extends React.Component<Props, { hasError: boolean }> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    this.setState({ hasError: true });
    try {
      import('@/lib/analytics').then((m) => {
        try {
          (m.default as any).trackEvent('COMPONENT_RENDER_ERROR', { component: this.props.component || 'unknown', message: String(error && error.message), info });
        } catch {}
      }).catch(() => {});
    } catch {}
    // Also keep a console.error for local debugging
    // eslint-disable-next-line no-console
    console.error('LocalErrorBoundary caught error', this.props.component || '', error, info);
  }

  render() {
    if (this.state.hasError) {
      return null;
    }
    return this.props.children as any;
  }
}
